import React, { useState } from 'react';
import cls from 'classnames';
import Styles from './index.css';
type SizeType = 'tiny' | 'small' | 'middle' | 'large';
export interface AvatarProps {
  size: SizeType | number;
  src: string;
  className: string;
  style: React.CSSProperties;
  vwSize: number;
  onClick: React.MouseEventHandler;
  needForceUpdate?: boolean;
  borderColor?: string;
  borderSize?: number;
}

const Avatar: React.FC<Partial<AvatarProps>> = ({
  size = 'small',
  src,
  className,
  vwSize,
  children,
  style,
  needForceUpdate = true,
  borderColor = 'rgba(22, 24, 35, 0.12)',
  borderSize = 1,
  ...props
}) => {
  const [useFallbackAvatar, setUseFallbackAvatar] = useState(false);
  const [, setLoaded] = useState(false);
  const sizeMap = {
    tiny: 24,
    small: 48,
    middle: 56,
    large: 72
  };
  let uuid = 0;
  let _size = size;

  if (typeof size === 'string') {
    _size = sizeMap[size];
  }

  const handleImageError = () => {
    setUseFallbackAvatar(true);
  };

  const avatar = src ? src.replace(/.webp$/, '.jpeg') : '//sf16-sg.tiktokcdn.com/obj/eden-sg/vhogeh7psuhpa/activity_referral/default-avatar.svg';
  const wrapperCls = cls(Styles['avatar'], className, {
    [Styles['is-children']]: children
  });
  const avatarStyle = {
    border: `${borderSize}px solid ${borderColor}`,
    width: vwSize ? `${vwSize}vw` : `${_size}px`,
    height: vwSize ? `${vwSize}vw` : `${_size}px`
  };
  return <span className={wrapperCls} {...props} style={{ ...style,
    ...avatarStyle
  }}>
      {children ? children : <img style={{
      width: '100%',
      height: '100%'
    }} key={needForceUpdate ? uuid++ : null} onLoad={() => {
      setLoaded(true);
    }} src={useFallbackAvatar ? '//sf16-sg.tiktokcdn.com/obj/eden-sg/vhogeh7psuhpa/activity_referral/default-avatar.svg' : avatar} onError={handleImageError} />}
    </span>;
};

export default Avatar;